import { apiUrl } from "./api";

export interface ServerStatus {
  id: number;
  name: string;
  last_seen_at: string | null;
  player_count: number | null;
}

export interface ServersResponse {
  servers: ServerStatus[];
}

export async function fetchServers(): Promise<ServersResponse> {
  const url = apiUrl("/servers");
  const response = await fetch(url.toString());
  if (!response.ok) throw new Error(`Failed to fetch servers: ${response.status}`);
  return response.json() as Promise<ServersResponse>;
}
